

import axios from 'axios';
const instance = axios.create({
  baseURL: '/',
  header: {
    'Content-Type': 'application/json',
  },
  headers: { 'X-Requested-With': 'XMLHttpRequest' },
});

instance.interceptors.request.use(
  config => config,
  error =>{
    return Promise.reject(error)
  }
)

instance.interceptors.response.use(
  res =>{
    return res.data;
  },
  error =>{
    if (error.response.status == '401') {
      store.commit('setState', { key: 'isLogged', value: false })
      store.commit('setState', { key: 'userInfo', value: null })
      Vue.prototype.$cookie.set("LID", '', { domain: '.agriknow.cn', expires: -1 });
      Vue.prototype.$cookie.set("AID", '', { domain: '.agriknow.cn', expires: -1 });
      Vue.prototype.$cookie.set("LID", '', { domain: 'ai.agriknow.cn', expires: -1 });
      Vue.prototype.$cookie.set("AID", '', { domain: 'ai.agriknow.cn', expires: -1 });
      return error.response.data;
    }
    return Promise.reject(error);
  }
);

export default {
  get(url, data, config = {})
  {
    return instance.get(url, { params: data, ...config })
  },
  post(url, data, config = {})
  {
    return instance.post(url, data, { ...config })
  },
}




